// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__q-GAc","actions":"GroupTable_actions__b_MS6","deleteModalFooter":"GroupTable_deleteModalFooter__2sn_v"};